import Vue from 'vue';
import Router from 'vue-router';
import Register from './views/acerto/Register.vue';
import PrivacyPolicy from './views/acerto/PrivacyPolicy.vue';
import HelpCenter from './views/acerto/HelpCenter.vue';
import TermsOfUse from './views/acerto/TermsOfUse.vue';


Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      beforeEnter() {
        window.location.href = 'https://www.omni.com.br/404';
      },
    },
    {
      path: '/',
      name: 'root',
      redirect: {
        name: 'register',
      },
    },
    {
      path: '/cadastro',
      name: 'register',
      component: Register,
    },
    {
      path: '/politica-de-privacidade',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/termos-de-uso',
      name: 'terms-of-use',
      component: TermsOfUse,
    },
    {
      path: '/central-de-ajuda',
      name: 'help-center',
      component: HelpCenter,
    },
  ],
});
